import { GPS_FIX_MAX_USABLE_DOP } from '../analysis/config/telemetryChecks'
import { calculateDistance } from '../utils/distanceUtils'

export interface GpsFixReading {
  timeMs: number
  latitude: number
  longitude: number
  speedKmh?: number
  dop?: number
}

export const isOnTheGlobe = ({ latitude, longitude }: GpsFixReading): boolean =>
  Number.isFinite(latitude) &&
  Number.isFinite(longitude) &&
  Math.abs(latitude) <= 90 &&
  Math.abs(longitude) <= 180 &&
  !(latitude === 0 && longitude === 0)

const isPreciseEnough = ({ dop }: GpsFixReading): boolean =>
  dop === undefined || dop <= GPS_FIX_MAX_USABLE_DOP

export const isUsableGpsFix = (fix: GpsFixReading): boolean =>
  Number.isFinite(fix.timeMs) && isOnTheGlobe(fix) && isPreciseEnough(fix)

export const metresBetween = (from: GpsFixReading, to: GpsFixReading): number =>
  calculateDistance(from.latitude, from.longitude, to.latitude, to.longitude)
